import { IRequestCommand } from '../connection/iRequestCommand';
import {
  ErrorDetails,
  ICarrierBranchResponseDTO
} from '../connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../connection/commandRequestType';
import { ICommandParameters } from '../connection/iCommandParameters';
import { ICommandResponse } from '../connection/iCommandResponse';

export class UpdateFirebaseTokenCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  string
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'users/updateFirebaseToken';
}

export interface UpdateCarrierFirebaseTokenParameters
  extends ICarrierBranchResponseDTO,
    ICommandParameters {
    userId?: string;
    token?: string;
}
